import { validateImageDimensions } from "@/helpers/file-helpers";
import { ImageValidationMessages } from "@/messages/images/Image-validation.messages";

export const readAndValidateImage = (
  messages: ImageValidationMessages,
  file: File,
  onValidationSuccess: (imageWithPreview: {
    file: File;
    preview: string | ArrayBuffer | null;
  }) => void,
  onValidationError: (message: string) => void
): void => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = new window.Image();
    img.onload = () => {
      if (validateImageDimensions(img)) {
        const preview = e.target?.result || null;
        onValidationSuccess({ file, preview });
      } else {
        onValidationError(messages.imageDimensionsExceeded);
      }
    };

    img.src = e.target?.result?.toString() || "";
  };

  reader.readAsDataURL(file);
};
